import type { App } from 'vue'
import AppPopup from '@/components/AppPopup/AppPopup.vue'
import CalendarInput from '@/components/CalendarInput/CalendarInput.vue'
import FileInput from '@/components/FileInput/FileInput.vue'
import FormElement from '@/components/FormElement/FormElement.vue'
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue'

const globalComponents = (app: App) => {
  app.component('SvgIcon', SvgIcon)
  app.component('FormElement', FormElement)
  app.component('AppPopup', AppPopup)
  app.component('FileInput', FileInput)
  app.component('CalendarInput', CalendarInput)
}
export default globalComponents
